import blobPath from './blobPath';
import GetfacilityTypeData from './GetfacilityTypeData';
import GetManagementStatus from './GetManagementStatus';
const isLogin = window.SIMPL.isLogin;

export default function markerContent(resultValue, resultValueArray) {

    if (resultValueArray == null) {
        resultValueArray = [];
        resultValueArray.push(resultValue);
    }

    let contentString = "";

    // 画像は1件目を表示
    if (resultValue.PhotoURL != null) {
        contentString = '<img src=' + blobPath(resultValue.ThumbnailURL === null ? resultValue.PhotoURL : resultValue.ThumbnailURL) + ' height=130px width=195px>';
    }

    //写真は同一位置のデータがあっても個々表示
    if(resultValue.type === "photo"){
        if (resultValue.PhotoURL != null && resultValueArray.length > 1) {
            contentString = '<span className="test"><img src=' + blobPath(resultValue.ThumbnailURL === null ? resultValue.PhotoURL : resultValue.ThumbnailURL) + ' height=130px width=195px>'
            +'<i class="bi bi-images"style="position: absolute;top: 15px;right: 21px;font-size: 25px;height: 28px;width: 29px;background-color: white;padding: 0 2px;"></i></span>';
        }
        let tagString = "";

        (resultValue.tags).forEach(element => {
            tagString = tagString + '<button class="tag link-style-btn" value='+ element +' style="font-weight:bold;word-break:break-all;word-wrap:break-word;text-align:left;">#' + element + '</button>';
        });
            
        contentString = contentString +
        '<span style="display:block;margin-bottom:3px;width:195px;">' +
        '<span style="display:flex;justify-content:space-between;">' +
        '<p style="margin: 3px 0;font-size: 12px;max-width: 95px;line-height: 1.2;word-wrap: break-word;">' + tagString + '</p>' +
        '<p style="margin:3px 0;font-size:12px;text-align:right;">' + resultValue.filmingDateTime + '</p></span></span>';
    }

    //施設は同一位置のデータがあったら表示
    for (let i = 0; i < resultValueArray.length; i++) {

        let facility = resultValueArray[i];

        switch(facility.type){
            case "photo":
                //重ねない
                break;
            case "report":
            case "trafficregulation":
                let titleString= "";
                if (isLogin) {
                    titleString = "<a target='_blank' rel='noopener noreferrer' href='" + window.location.origin + '/Detail/Details/' + facility.id + "'>" +
                    '<p>' + facility.title + '</p>' +
                    '</a>';
                }else{
                    titleString = '<a class="title-btn" name="' + facility.id + '" style="margin: 3px 0;font-size: 12px;max-width: 95px;line-height: 1.2;word-wrap: break-word;text-align:left;">' + facility.title + '</a>';
                }

                let typeString = GetfacilityTypeData(facility.type,"name");

                let dateString= "";
                if (facility.type === "report") {
                    dateString = facility.reportDate;
                }
                if(facility.type === "trafficregulation") {
                    dateString = facility.applicationDate;
                }

                let statusString= "";
                if (facility.type === "report") {
                    statusString = GetManagementStatus("reportStatus",facility.reportStatus,"name");
                }
                if(facility.type === "trafficregulation") {
                    statusString = GetManagementStatus("applicationStatus",facility.applicationStatus,"name");
                }

                contentString = contentString +
                '<span style="display:block;margin-bottom:3px;width:195px;">' +
                '<span style="display:flex;justify-content:space-between;">' +
                '<span style="display:flex;flex-direction:column;">' +
                titleString +
                '<p style="margin: 3px 0;font-size: 12px;max-width: 95px;line-height: 1.2;word-wrap: break-word;text-align:left;">' + typeString + '</p>' +
                '<p style="margin: 3px 0;font-size: 12px;max-width: 95px;line-height: 1.2;word-wrap: break-word;">' + statusString + '</p>' +
                '</span>'+
                '<p style="margin:3px 0;font-size:12px;text-align:right;">' + dateString + '</p></span></span>';
                break;
            case "pavement10":
            case "pavement100":
                //写真不要の為、一度クリア
                contentString = "";
                contentString += '<p style="margin:3px 0;">路線番号: ' + facility.Roadtitle + '</p>';
                contentString += '<p style="margin:3px 0;">事務所: ' + facility.componentManagerOffice + '</p>';
                var roadBoard ="";
                switch(facility.roadBoard){
                    case "1":
                        roadBoard = "上り";
                        break;
                    case "2":
                        roadBoard = "下り";
                        break;
                    case "3":
                        roadBoard = "上下";
                        break;
                    case "9":
                        roadBoard = "その他";
                        break;
                    default:
                        roadBoard = facility.roadBoard;
                        break;
                }
                contentString += '<p style="margin:3px 0;">上下線: ' + roadBoard + '　車線: ' + facility.laneCode + '</p>';
                contentString += '<p style="margin:3px 0;">KP: ' + facility.startPosition + "－" + facility.endPosition + '</p>';
                contentString += '<p style="margin:3px 0;">健全性: ' + facility.overallHealthLevel + '</p>';
                contentString += "<a target='_blank' rel='noopener noreferrer' href='" + blobPath(facility.originalDataURL) + "'>"+ facility.componentManagerOffice + "_" + facility.Roadtitle +'</a>';

                break;
            default:
                // 施設名+管理事務所
                let title;
                if (facility.title !== null) {
                    title = '<span>' + facility.title + '</span>'
                }
                let componentManagementOffice;
                if (facility.componentManagerOffice !== null && facility.componentManagerOffice !== undefined) {
                    componentManagementOffice = '<span style="font-size:0.7em;">（' + facility.componentManagerOffice + '）</span>'
                }
                contentString = contentString +
                    "<a target='_blank' rel='noopener noreferrer' href='" + window.location.origin + '/Detail/Details/' + facility.id + "'>" +
                    '<h4>' + title + componentManagementOffice + '</h4>' +
                    '</a>';


                if(facility.type === "pavement20" || facility.type === "pavement100" || facility.type === "cavitysensor" )
                {
                    
                }else{
                    // 所在地
                    if (facility.address === null || facility.address === undefined) {
                        contentString = contentString + '<p>所在地: 不明</p>'; //IE11で??演算子構文が使えない
                    } else {
                        contentString = contentString + '<p>所在地: ' + facility.address + '</p>';
                    }
                }
                
                // 路線名
                if ((facility.endLat !== null && facility.endLng !== null) || facility.type === "cavity"|| facility.type === "cavitysensor") {
                    if (facility.Roadtitle == null) {
                        contentString = contentString + '<p>路線名: 不明</p>'; //IE11で??演算子構文が使えない
                    } else {
                        contentString = contentString + '<p>路線名: ' + facility.Roadtitle + '</p>';
                    }
                }
                break;
        }
    
    }
    return contentString;
}
